import { IEmailCampaign } from "../interface/emails/IEmailCampaign";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";


enum EmailCampaignServiceEnum {

  create = "/create",
  getAllCampaigns = "/get-all",
  getById = "/get-by-id",
  update = "/update",
}

export default class EmailCampaignService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/campaign/email");
  }

  public create = async (emailCampaign: IEmailCampaign): Promise<void> =>
    await this.POST(EmailCampaignServiceEnum.create, emailCampaign);

  public getAllCampaigns = async (): Promise<IEmailCampaign[]> => await this.GET(EmailCampaignServiceEnum.getAllCampaigns);

  public getById = async (id: number): Promise<IEmailCampaign> =>
    await this.GET(`${EmailCampaignServiceEnum.getById}?id=${id}`);

  public update = async (emailCampaign: IEmailCampaign): Promise<void> =>
    await this.POST(EmailCampaignServiceEnum.update, emailCampaign);

}
